import React from "react";
import whyMatterImage from "../../assets/whyMatterImage.png";
import { useTranslation } from "react-i18next";

export default function Whymatters() {
  const { t } = useTranslation();
  return (
    <div className="bg-[#f6fcff] min-h-[70vh] md:min-h-[90vh] px-4 py-16 relative overflow-hidden">
      <section className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-16 h-full relative">
        {/* Left: Text Content */}
        <div className="flex flex-col justify-center w-full md:w-1/2 space-y-6 z-10">
          <h3 className="font-arya text-xl md:text-3xl font-semibold">
            {t("about.whyTitle")}
          </h3>
          <p className="text-base md:text-md text-gray-700 leading-relaxed">
            {t("about.whyPara1")}
          </p>
          <p className="text-base md:text-md text-gray-700 leading-relaxed">
            {t("about.whyPara2")}
          </p>
        </div>

        {/* Right: Image */}
        <div className="flex-shrink-0 w-full md:w-1/2 relative">
          <img
            src={whyMatterImage}
            alt="Why it matters"
            className="hidden lg:block absolute top-[-200px] right-[-120px] h-[95vh] object-contain z-10"
          />
        </div>
      </section>
    </div>
  );
}
